import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "dialog-footer" }

import {
  ref,
  computed,
  onMounted,
  inject,
  watch,
  nextTick,
} from "vue";
import { remarkForApi } from "@/core/helpers/remark";
import ApiService from "@/core/services/Transaction.ts";
import ApiAccountService from "@/core/services/Account.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";
import SvgSprite from "@/components/shared/SvgSprite.vue";

import { useRoute, useRouter } from "vue-router";

import PaymentDetail from "@/views/sellstock/transaction/PayDetail";

interface BankOption {
  value: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrder',
  props: {
  modelValue: Boolean,
},
  setup(__props, { expose: __expose, emit: __emit }) {

const route = useRoute();
const router = useRouter();

const $loading = inject("$loading") as LoadingService;

const selectedProviderMethod = ref("");

const providerMethods = ref<{ label: string; value: string }[]>([]);

const loadDepositProviders = async () => {
  const resp = await ApiAccountService.depositProviders();
  const codes = Array.isArray(resp?.data) ? resp.data : [];
  providerMethods.value = codes
    .filter((code: string) => typeof code === "string" && code.trim() !== "")
    .map((code: string) => {
      const value = code.trim().toLowerCase();
      return { label: value.toUpperCase(), value };
    });
  const stillValid = providerMethods.value.some(
    (method) => method.value === selectedProviderMethod.value
  );
  if (!stillValid) {
    selectedProviderMethod.value = providerMethods.value[0]?.value || "";
  }
};

const userAccounts = ref("");

const inputAmount = ref("");
const inputRemark = ref("");
const inputOrderId = ref("");

const amountInput = ref<HTMLInputElement | null>(null);

const isDialogPayment = ref(false);
const selectedOrder = ref(null);

const props = __props;

const dialogData = ref({
  bank: "",
  account_number: "",
  first_name: "",
  last_name: "",
});

const banks: BankOption[] = [
  { value: "bbl", label: "Bangkok Bank" },
  {
    value: "baac",
    label: "Bank for Agriculture and Agricultural Cooperatives",
  },
  { value: "bay", label: "Bank of Ayudhya" },
  { value: "cimb", label: "CIMB Thai Bank" },
  { value: "gov", label: "Government Savings Bank" }, // gov
  { value: "kbank", label: "Kasikorn Bank" },
  { value: "kk", label: "Kiatnakin Phatra Bank" }, // kk
  { value: "ktb", label: "KTB" },
  { value: "scb", label: "SCB" },
  { value: "ttb", label: "TMB Thanachart Bank" },
  { value: "uobt", label: "United Overseas Bank (Thai)" },
];

const emit = __emit;

const isDialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const resetFields = () => {
  selectedProviderMethod.value = "";
  inputAmount.value = "";
  inputRemark.value = "";
  inputOrderId.value = "";
  isDialogVisible.value = false;
  dialogData.value = {
    bank: "",
    account_number: "",
    first_name: "",
    last_name: "",
  };
};

const handleDialogClose = () => {
  emit("update:modelValue", false);
  // if (route.path.includes("sellstock/transaction")) {
  //   window.location.reload();
  // }
  resetFields();
};

watch(selectedProviderMethod, (newVal) => {
  if (newVal === 1 || newVal === 2) {
    // if (!userAccounts.value) {
    fetchUserAccounts();
    // }
  }
});

const handlePay = (item: any) => {
  isDialogVisible.value = true;
};

const submitPayment = async (order) => {
  $loading.startLoading();
  if (selectedProviderMethod.value) {
    let payload: any = {
      provider: selectedProviderMethod.value,
    };

    if (inputAmount.value < 0 || inputAmount.value > 200000) {
      ElNotification({
        title: "Error",
        message: "Amount must be between 0 and 200,000",
        type: "error",
      });
      $loading.endLoading();
      return;
    }

    payload.amount = parseFloat(inputAmount.value);
    payload.remark = remarkForApi(inputRemark.value);
    payload.order_id = inputOrderId.value;

    payload.user_bank_account = dialogData.value.bank;
    payload.user_account_number = dialogData.value.account_number;
    payload.user_name =
      dialogData.value.first_name + " " + dialogData.value.last_name;

    const resp = await ApiAccountService.PayWithProvider(payload);
    if (resp.payment) {
      selectedOrder.value = resp.payment;
      await nextTick();
      isDialogPayment.value = true;
      ElNotification({
        title: "Success",
        message: resp.message,
        type: "success",
      });

      resetFields();
    } else {
      ElNotification({
        title: "Error",
        message: resp.error || resp.msg,
        type: "error",
      });
    }
  } else {
    ElNotification({
      title: "Error",
      message: "Please select a Provider.",
      type: "error",
    });
  }
  $loading.endLoading();
};

const closeUploadDialog = () => {
  isDialogPayment.value = false;
  selectedOrder.value = null;
};

const initData = (data: any) => {
  selectedProviderMethod.value = (data.provider || "").toLowerCase();
  inputAmount.value = data.amount ? data.amount.toString() : "";
  inputRemark.value = data.remark || "";
  
  let accNum = data.raw_user_account_number || data.user_account_number || "";
  if (accNum && (accNum.includes("(") || accNum.includes("-"))) {
    const match = accNum.match(/\(([^-]+)-([^)]+)\)/);
    if (match) {
      accNum = match[2];
    }
  }

  inputOrderId.value = data.merchant_order_id || data.order_id || "";

  const names = (data.user_name || "").trim().split(/\s+/);
  dialogData.value = {
    bank: (data.user_bank_account || "").toLowerCase(),
    account_number: accNum,
    first_name: names[0] || "",
    last_name: names.slice(1).join(" ") || "",
  };
};

__expose({
  initData,
});

watch(
  () => isDialogVisible.value,
  (newVal) => {
    if (newVal) {
      loadDepositProviders();
      nextTick(() => {
        const inputEl = amountInput.value?.$el?.querySelector("input");
        if (inputEl) {
          inputEl.focus();
        }
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: isDialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isDialogVisible).value = $event)),
      title: "Create Order",
      width: "500",
      "align-center": "",
      "close-on-click-modal": false,
      onClose: handleDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            variant: "flat",
            size: "large",
            rounded: "md",
            type: "danger",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (resetFields()))
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            variant: "flat",
            size: "large",
            rounded: "md",
            type: "primary",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (submitPayment()))
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("Create ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("Order ID or Merchant Order ID ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: inputOrderId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputOrderId).value = $event)),
                density: "comfortable",
                required: "",
                "hide-details": "auto",
                variant: "outlined",
                color: "primary",
                onKeyup: _withKeys(submitPayment, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode("Please enter an amount")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: inputAmount.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputAmount).value = $event)),
                placeholder: "0 - 200,000",
                density: "comfortable",
                required: "",
                "hide-details": "auto",
                variant: "outlined",
                color: "primary",
                maxlength: "10",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (
            inputAmount.value = inputAmount.value
              .replace(/[^0-9.]/g, '')
              .replace(/(\..*)\./g, '$1')
              .slice(0, 10)
          )),
                rules: [
            (v) => !!v || 'Amount is required',
            (v) => {
              const numberValue = parseFloat(v);
              return (
                (numberValue >= 0 && numberValue <= 200000) ||
                'Amount must be between 0 and 200,000'
              );
            },
            (v) =>
              /^\d+(\.\d{1,2})?$/.test(v) ||
              'Amount must be a valid decimal with up to two decimal places',
          ],
                onKeyup: _withKeys(submitPayment, ["enter"])
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createVNode(_component_v_label, { class: "mt-2 mr-2" }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("Choose Provider")
              ])),
              _: 1
            }),
            _createVNode(_component_el_radio_group, {
              modelValue: selectedProviderMethod.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedProviderMethod).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providerMethods.value, (method) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: method.value,
                    label: method.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(method.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("Please enter a remark")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                modelValue: inputRemark.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputRemark).value = $event)),
                placeholder: "Remark",
                class: "mt-2",
                density: "comfortable",
                "hide-details": "auto",
                variant: "outlined",
                color: "primary",
                onKeyup: _withKeys(submitPayment, ["enter"]),
                maxlength: "50"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Bank")
                ])),
                _: 1
              }),
              _createVNode(_component_el_select, {
                modelValue: dialogData.value.bank,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogData.value.bank) = $event)),
                placeholder: "Please select a bank",
                size: "large",
                class: "v-input__control",
                rules: _ctx.bankRules,
                required: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(banks, (bank) => {
                    return _createVNode(_component_el_option, {
                      key: bank.value,
                      label: bank.label,
                      value: bank.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_label, null, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("Account Number")
                ])),
                _: 1
              }),
              _createVNode(_component_v_text_field, {
                "aria-label": "account_number",
                modelValue: dialogData.value.account_number,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogData.value.account_number) = $event)),
                maxlength: "12",
                class: "mt-2",
                density: "comfortable",
                variant: "outlined",
                color: "primary",
                rules: _ctx.accountNumberRules,
                required: ""
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_label, null, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("First Name")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_text_field, {
                      "aria-label": "first_name",
                      modelValue: dialogData.value.first_name,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogData.value.first_name) = $event)),
                      class: "mt-2",
                      density: "comfortable",
                      variant: "outlined",
                      color: "primary",
                      rules: _ctx.fnameRules,
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_label, null, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("Last Name")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_text_field, {
                      "aria-label": "last_name",
                      modelValue: dialogData.value.last_name,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogData.value.last_name) = $event)),
                      class: "mt-2",
                      density: "comfortable",
                      variant: "outlined",
                      color: "primary",
                      rules: _ctx.lnameRules,
                      required: ""
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(PaymentDetail), {
      modelValue: isDialogPayment.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isDialogPayment).value = $event)),
      selectedOrder: selectedOrder.value
    }, null, 8, ["modelValue", "selectedOrder"])
  ], 64))
}
}

})